import "@/App.css";

import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { Toaster } from "sonner";

import {
  ThemeProvider,
  useTheme,
} from "@/context/ThemeContext";

import {
  AuthProvider,
  useAuth,
} from "@/context/AuthContext";

import { WalletProvider } from "@/context/WalletContext";

import Layout from "@/components/Layout";

import SignUp from "@/pages/SignUp";
import LandingPage from "@/pages/Landing";
import ServicesPage from "@/pages/Services";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import LoginPage from "@/pages/Login";

import {
  PrivacyPage,
  TermsPage,
} from "@/pages/Legal";

import Ledger from "./pages/Ledger";
import Profile from "./pages/Profile";
import ChangePassword from "./pages/ChangePassword";
import ForgotPassword from "./pages/ForgotPassword";
import WalletTopUp from "./pages/WalletTopUp";
import Razorpay from "./pages/WalletTopUp1 copy";
import PayUMoney from "./pages/PayUMoney";
import Manual from "./pages/Manual";



import FillMyForm from "./pages/FillMyForm/FillMyForm";

import fillMyFormRoutes from "./pages/FillMyForm/routes";
import modifyMyFormRoutes from "./pages/ModifyMyForm/routes";


/*
 * Main home page
 *
 * Not logged in:
 *   / -> Landing Page
 *
 * Logged in:
 *   / -> Fill My Form
 */
const HomePage = () => {
  const { user } = useAuth();

  return user
    ? <FillMyForm />
    : <LandingPage />;
};


const AppShell = () => {
  const { theme } = useTheme();

  return (
    <>
      <Layout>
        <Routes>

          {/* Main Home */}
          <Route
            path="/"
            element={<HomePage />}
          />

          <Route
            path="/signup"
            element={<SignUp />}
          />

          <Route
            path="/services"
            element={<ServicesPage />}
          />

          <Route
            path="/about"
            element={<AboutPage />}
          />

          <Route
            path="/contact"
            element={<ContactPage />}
          />

          <Route
            path="/login"
            element={<LoginPage />}
          />

          <Route
            path="/ledger"
            element={<Ledger />}
          />

          <Route
            path="/profile"
            element={<Profile />}
          />

          <Route
            path="/change-password"
            element={<ChangePassword />}
          />

          <Route
            path="/forgot-password"
            element={<ForgotPassword />}
          />

          <Route
            path="/wallet"
            element={<WalletTopUp />}
          />

          <Route path="/razorpay" element={<Razorpay />} />

          <Route path="/payumoney" element={<PayUMoney />} />

          <Route path="/manual" element={<Manual />} />

          <Route
            path="/privacy"
            element={<PrivacyPage />}
          />

          <Route
            path="/terms"
            element={<TermsPage />}
          />


          {/* Fill My Form routes */}
          {fillMyFormRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
            />
          ))}


          {/* Modify My Form routes */}
          {modifyMyFormRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
            />
          ))}


          {/* Unknown route */}
          <Route
            path="*"
            element={
              <Navigate
                to="/"
                replace
              />
            }
          />

        </Routes>
      </Layout>


      <Toaster
        position="top-right"
        theme={theme}
        richColors
        closeButton
        toastOptions={{
          style: {
            borderRadius: "14px",
          },
        }}
      />
    </>
  );
};


function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <WalletProvider>
            <AppShell />
          </WalletProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;